import { Injectable } from '@angular/core';
import { SpanAttributes, SpanOptions } from '@opentelemetry/api';
import { ObservabilityService } from './observability-service';
import { LocalStorageService, MetaTags, MetaTagsService } from '@mode/shared/util-js';

const NAMESPACE = '__mode-';

const localStorageKeys = {
  NewReportStartTime: `${NAMESPACE}new-report-start-time`,
  ClickedNewReport: `${NAMESPACE}clicked-new-report`,
};

/**
 * @deprecated
 *
 * This service no longer has relevance with Datasets having been
 * widely released.
 *
 * It's more likely you'll want to look at the nearby `ReportCreationObservabilityService`.
 *
 * This service should be deleted during the datasets feature flag cleanup.
 */
@Injectable({
  providedIn: 'root',
})
export class CreateNewReportObservabilityService {
  constructor(
    private observabilityService: ObservabilityService,
    private localStorageService: LocalStorageService,
    private metaTagsService: MetaTagsService
  ) {}

  public setEventStartTime(): void {
    this.localStorageService.removeItem(localStorageKeys.NewReportStartTime);
    this.localStorageService.setItem(localStorageKeys.NewReportStartTime, new Date().toString());

    this.localStorageService.removeItem(localStorageKeys.ClickedNewReport);
    this.localStorageService.setItem(localStorageKeys.ClickedNewReport, true.toString());
  }

  private defaultSpanAttributes() {
    const result: SpanAttributes = {
      'mode.webapp_ui.current_username': this.metaTagsService.getTag(MetaTags.CurrentUsername) ?? 'not-available',
      'mode.webapp_ui.owner_username': this.metaTagsService.getTag(MetaTags.OwnerUsername) ?? 'not-available',
    };

    return result;
  }

  public captureTimedTrace() {
    const defaultAttrs = this.defaultSpanAttributes();
    if (this.localStorageService.getItem(localStorageKeys.ClickedNewReport)) {
      const traceNewReportStartTime = this.localStorageService.getItem(localStorageKeys.NewReportStartTime);
      let traceBeginAt: Date | undefined;

      if (traceNewReportStartTime) {
        traceBeginAt = new Date(traceNewReportStartTime);
      }
      const spanOptions: SpanOptions = {
        startTime: traceBeginAt,
        attributes: this.observabilityService.createSpanAttributes({ ...defaultAttrs }),
      };
      this.observabilityService.startTrace('create-new-report', spanOptions).end();
      this.localStorageService.removeItem(localStorageKeys.ClickedNewReport);
    }
  }
}
